import React from "react";

const Name = (cell) => {
    return cell.value ? cell.value : '';
};

const Created_at = (cell) => {
    return cell.value ? cell.value : '';
};

const Active = (cell) => {
    return cell.value==="Baja" ? <label className="text-white bg-danger text-center  p-1" style={{width:'100%'}} >{'Baja'} </label>: <label className="text-center p-1" style={{backgroundColor:'green',color:"white",width:'100%'}}>{'Activo'}</label> ;
};

const Options = ({cell, onEdit, onHlandleGetQr, onDelete, onReceiptPropertyModal}) => {
    const prop = cell.row.original
    return <div className="btn-group">
        {prop?.status!== 'Baja' && <button title="Editar" className="btn btn-primary" onClick={() => onEdit(cell.row.original)}><i className="fa fa-edit"></i></button>}
        <button className="btn btn-info" onClick={() => onHlandleGetQr(cell.row.original)}><i className="fa fa-qrcode"></i></button>
        {prop?.status!== 'Baja' && <button title="Dar de BAJA" className="btn btn-warning" onClick={() => onEdit(cell.row.original, 'Discontinued')}><i className="fa fa-circle"></i></button>}
        <button title = "Eliminar" className="btn btn-danger" onClick={() => onDelete(cell.row.original)}><i className="fa fa-trash"></i></button>
        <button className="btn btn-success" title="Obtener resguardo del bien" onClick={() => onReceiptPropertyModal(cell.row.original)}><i className="fa fa-file-pdf"></i></button>
    </div>;
};

export {
    Name,
    Created_at,
    Active,
    Options
};
